export default {"src":"/customer-services/_next/static/media/manufacturer.d4f87ee5.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};